/**
 * Brand panel — pane fijo a la izquierda en el AuthScreen split.
 * Headline cross-fades entre login/register, lo demás es estable.
 */
export const BrandPanel = ({ mode }) => {
  const isLogin = mode === 'login';
  return (
    <div className="brand-pane">
      <div className="brand-orb brand-orb-1" />
      <div className="brand-orb brand-orb-2" />
      <div className="brand-inner">
        <div className="brand-badge">TORNEOSPRO</div>
        <img
          src="/assets/icons/icon-512x512.png"
          alt="TorneosPro"
          className="brand-logo"
        />

        <div className="brand-msg-stage">
          <div className={`brand-msg ${isLogin ? 'is-active' : 'is-out'}`}>
            <h2>Bienvenido<br/>de vuelta</h2>
            <p>Tu panel de control para gestionar torneos profesionales te espera.</p>
          </div>
          <div className={`brand-msg ${!isLogin ? 'is-active' : 'is-out'}`}>
            <h2>Empieza<br/>gratis hoy</h2>
            <p>Crea tu primer torneo en menos de 2 minutos. Sin tarjeta. 12 deportes disponibles.</p>
          </div>
        </div>

        <ul className="brand-features">
          <li>Resultados en directo</li>
          <li>Inscripciones online por QR</li>
          <li>App en el móvil con avisos automáticos</li>
          <li>Patrocinadores con tracking</li>
        </ul>

        <div className="brand-stat">
          <span className="brand-stat-num">12</span>
          <span className="brand-stat-label">deportes<br/>soportados</span>
          <div className="brand-stat-divider" />
          <span className="brand-stat-num">2 min</span>
          <span className="brand-stat-label">setup<br/>medio</span>
        </div>
      </div>
    </div>
  );
};

export default BrandPanel;
